export default class ListMostRecentAttachmentRecordsByParentIdWithLimitError extends Error {

}
